import {Body_16_Coral_Emphasis_16} from "@UI/typography/generated/typography.tsx";
import {Gt} from "@src/i18n/Gt.tsx";
import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import {Colors} from "@UI/theme/generated/Colors.ts";
import {WorkdayStatusEnum, WorkdayWithEmployee} from "@src/httpClient/__generated__/Api.ts";
import styles from "./workStatus.module.less"
import {CircleWarning} from "@UI/components/icons/CircleWarning.tsx";


export enum EmployeeStatus {
    atWork = "At work",
    notAtWork = "Not at work",
    clockedOut = "Already clocked out",
    wrongData = "Unable to confirm",
}

export const colorsMap = {
    [EmployeeStatus.atWork]: Colors.Coral_green_500,
    [EmployeeStatus.notAtWork]: Colors.Coral_fire_400,
    [EmployeeStatus.clockedOut]: Colors.Obsidian_Light_400,
    [EmployeeStatus.wrongData]: Colors.Coral_mango_500,
}


export type WorkdayState = Pick<WorkdayWithEmployee, "status" | "inconsistent">

// Badge status from the workday's backend state, which tas recalculates
// on every stamp.
export const workdayStatus = (workday?: WorkdayState | null) => {
    if (!workday) return EmployeeStatus.notAtWork
    if (workday.inconsistent) return EmployeeStatus.wrongData
    switch (workday.status) {
        case WorkdayStatusEnum.Working:
            return EmployeeStatus.atWork
        case WorkdayStatusEnum.Finished:
            return EmployeeStatus.clockedOut
        default:
            return EmployeeStatus.notAtWork
    }
}

export const WorkStatus = ({workday}: {workday?: WorkdayState | null}) => {
    const status = workdayStatus(workday)
    return (
        <Stack className={styles.workStatus} style={{backgroundColor: colorsMap[status]}}
               alignItems={"center"} justifyContent={"center"}>
            {status === EmployeeStatus.wrongData && <CircleWarning size={18} /> }
            <Body_16_Coral_Emphasis_16>
                <Gt prefix={"employee_statuses"}>{status}</Gt>
            </Body_16_Coral_Emphasis_16>
        </Stack>

    )
}